import { render, staticRenderFns } from "./StudentInnerTable.vue?vue&type=template&id=a4975ba2&scoped=true"
import script from "./StudentInnerTable.vue?vue&type=script&lang=js"
export * from "./StudentInnerTable.vue?vue&type=script&lang=js"
import style0 from "./StudentInnerTable.vue?vue&type=style&index=0&id=a4975ba2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4975ba2",
  null
  
)

export default component.exports